/* eslint-disable */
const backo = ({ min = 1000, max = 5000, jitter = 0.5 }) => {
  let attempts = 0;
  return {
    duration: () => {
      let ms = min * Math.pow(2, attempts++);

      if (jitter) {
        const rand = Math.random();
        const deviation = Math.floor(rand * jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
      }

      return Math.min(ms, max) | 0;
    },
    reset: () => {
      attempts = 0;
    },
  };
};
/* eslint-enable */

export default backo;
